import { useThemesStore } from 'stores/useThemesStore';
import { partition } from 'lodash';

let isFetching = false;

export const fetchFavourites = async () => {
  if (isFetching) return false;
  if (typeof App === 'undefined' || !App.order.logged_in()) return false;

  isFetching = true;
  try {
    await useThemesStore.getState().some();
    const [favourited] = partition(
      useThemesStore.getState().themes,
      'favourite',
    );

    return favourited;
  } finally {
    isFetching = false;
  }
};
